/**
 * Citation Builder wizard step ids — the legal values of the `$step` URL
 * segment. They are the app's URL contract (same category as
 * `featureFlagsKeys.ts` / `capabilities.ts`), so they live in `shared/consts`
 * rather than the feature: `shared/routes.ts` needs the `BuilderStep` type to
 * type the step-route builder, and `shared` must never import from a feature.
 *
 * The wizard behaviour that operates on these ids (step ordering maths,
 * accessibility gating, the store, `STEP_COMPONENTS`) stays feature-side.
 */
export const BUILDER_STEPS = {
  SCAN: 'scan',
  FIX: 'fix',
  BUILD: 'build',
  AGGREGATORS: 'aggregators',
  DELIVERY: 'delivery',
  REVIEW: 'review'
} as const;

/** Wizard steps in flow order — drives step indexing and the progress stepper. */
export const BUILDER_STEP_ORDER = [
  BUILDER_STEPS.SCAN,
  BUILDER_STEPS.FIX,
  BUILDER_STEPS.BUILD,
  BUILDER_STEPS.AGGREGATORS,
  BUILDER_STEPS.DELIVERY,
  BUILDER_STEPS.REVIEW
] as const;

/** A single wizard step id — the legal values of the `$step` URL segment. */
export type BuilderStep = (typeof BUILDER_STEPS)[keyof typeof BUILDER_STEPS];
